import {
  IfIsaAccount,
  IfIsaTransfer,
  IfIsaYearlyContribution,
} from "@ifgengineering/client-invest-sdk";
import { RootState } from "../rootReducer";

export const isIfIsaAccountLoadingSelector = (state: RootState): boolean =>
  state.ifIsa.account.loading;
export const isIfIsaAccountNeverLoadedSelector = (state: RootState): boolean =>
  state.ifIsa.account.neverLoaded;
export const getIfIsaAccountSelector = (
  state: RootState
): IfIsaAccount | null => state.ifIsa.account.data;

export const isIfIsaYearlyContributionLoadingSelector = (
  state: RootState
): boolean => state.ifIsa.yearlyContribution.loading;
export const isIfIsaYearlyContributionNeverLoadedSelector = (
  state: RootState
): boolean => state.ifIsa.yearlyContribution.neverLoaded;
export const getIfIsaYearlyContributionSelector = (
  state: RootState
): IfIsaYearlyContribution | null => state.ifIsa.yearlyContribution.data;

export const isIfIsaTransfersLoadingSelector = (state: RootState): boolean =>
  state.ifIsa.transfers.loading;
export const isIfIsaTransfersNeverLoadedSelector = (
  state: RootState
): boolean => state.ifIsa.transfers.neverLoaded;
export const getIfIsaTransfersSelector = (state: RootState): IfIsaTransfer[] =>
  state.ifIsa.transfers.data;
